// extracted by mini-css-extract-plugin
module.exports = {"policy":"PrivacyPolicy_policy__mDsKW","lastUpdated":"PrivacyPolicy_lastUpdated__u63Ys"};